import styled from "styled-components";

import * as Types from "Types";

const Wrap = styled.div<Types.Default>`
   display: flex;
   justify-content: center;
   align-items: center;
   & img {
      max-width: 100%;
      transition-property: transform;
      transition-duration: 0.2s;
      transition-timing-function: ease-out;
   }
   &:hover img {
      transform: scale(1.05);
   }
   ${({ css }) => css}
`;

export default function XSChannelIcon(props: Types.Atoms.ChannelIcon) {
   return (
      <Wrap {...props}>
         <img src={props.src as string} alt="" />
      </Wrap>
   );
}
